import { alpha, SvgIcon, SxProps, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import { C, V } from '../Layout';
import { useStyling } from '../Theme';

type IconButtonCardProps = {
    id: string;
    text: ReactElement;
    onClick: () => void;
    Icon: typeof SvgIcon;
    isButtonActivated?: boolean;
    containerSx?: SxProps;
};

export default (props: IconButtonCardProps) => {
    const { id, text, Icon, onClick, isButtonActivated = false, containerSx = {} } = props;
    const { theme } = useStyling();

    return (
        <V
            data-testid={id}
            className={'clickable'}
            gap={0.5}
            onClick={onClick}
            sx={{ width: 'fit-content', alignItems: 'center', ...containerSx }}
        >
            <C
                sx={{
                    height: '116px',
                    width: '116px',
                    backgroundColor: isButtonActivated
                        ? alpha(theme.palette.primary.main, 0.08)
                        : theme.palette.action.disabledBackground,
                    borderRadius: 1,
                    position: 'relative',
                    alignContent: 'center'
                }}
            >
                <SvgIcon
                    component={Icon}
                    sx={{
                        color: isButtonActivated ? theme.palette.primary.main : theme.palette.action.disabled,
                        fontSize: '60px',
                        width: '100%',
                        textAlign: 'center'
                    }}
                />
            </C>
            <Typography
                sx={{
                    fontSize: theme.typography.body1,
                    color: theme.palette.text.primary
                }}
            >
                {text}
            </Typography>
        </V>
    );
};
